import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueI18n from 'vue-i18n';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import ptBr from './i18n/vuetify/pt-br';
import en from './i18n/vuetify/en';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);
Vue.use(VueI18n);

const messages = {
    en: {
        $vuetify: en,
    },
    'pt-br': {
        $vuetify: ptBr,
    },
};

const i18n = new VueI18n({ locale: 'pt-br', messages, silentTranslationWarn: true });

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
    theme: {
        dark: (localStorage.dark && localStorage.dark === 'true'),
        themes: {
            light: {
                primary: colors.blue.darken2,
            },
            dark: {
                accent: '#6565bf',
            },
        },
    },
});
